export * from 'server/models/BerthCapability';


// WEBPACK FOOTER //
// ./data/models/BerthCapability.ts